import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import AccessTimeIcon from 'housecall-ui/dist/IconsAndImages/Icons/AccessTime';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';

const styles = (theme) => ({
  bannerContent: {
    width: '80%',
    display: 'flex',
    padding: 7,
    margin: 'auto',
    alignItems: 'center',
    justifyContent: 'center',
  },
  message: {
    color: theme.palette.textColor,
    lineHeight: 1.2,
    paddingLeft: 10,
    marginRight: 10,
  },
  iconStyle: {
    color: theme.palette.textColor,
    width: 32,
    height: 32,
  },
  headerBar: {
    padding: 2,
    backgroundColor: '#015099',
  },
});

@withStyles(styles)
export default class NoticeBar extends PureComponent {
  render() {
    const {
      classes, message, hasHeader, className, children,
    } = this.props;

    return (
      <HousecallThemeProvider>
        <div className={className}>
          {hasHeader && <div className={classes.headerBar} />}
          <Grid container className={classes.bannerContent}>
            <AccessTimeIcon className={classes.iconStyle} />
            <Typography variant="body2" className={classes.message}>
              {message}
            </Typography>
            { children }
          </Grid>
        </div>
      </HousecallThemeProvider>
    );
  }
}

NoticeBar.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  hasHeader: PropTypes.bool,
};

NoticeBar.defaultProps = {
  hasHeader: false,
  classes: {},
};
